module.exports = __webpack_public_path__ + "static/media/fileuploadicon.f8ba4b69.png";